<template>
  <div class="attendance-and-payroll-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              Attendance & Payroll

              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
              
            </div>
          </div>

          <div
            class="col-md-4"
            v-if="!restrictViewUsers"
          >
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc btn-shadow"
                @click="$router.push({ name: 'attendanceDetails' })"
              >
                Attendance Details
              </button>
              <button
                class="btn btn-ecdc btn-shadow"
                @click="$router.push({ name: 'payrollDetails' })"
              >
                Payroll Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="summary-list row row-cols-7">
        <div
          :key="`summary-key-${key}`"
          v-for="(dailyRecord, key) in dailyActiveBa"
          class="col"
        >
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                  {{
                    `${dailyRecord.day} ${dailyRecord.month} ${dailyRecord.year}`
                  }}
                <small>
                TOTAL ACTIVE BA
                </small>
              </h3>

              <div class="figure">
                {{ dailyRecord.number }}
                <small>BA</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-list row row-cols-7">
        <div
          :key="`summary-key-${key}`"
          v-for="(dailyRecord, key) in dailyActiveTl"
          class="col"
        >
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                {{
                    `${dailyRecord.day} ${dailyRecord.month} ${dailyRecord.year}`
                }}
                <small>
                  TOTAL ACTIVE TL
                </small>
              </h3>

              <div class="figure">
                {{ dailyRecord.number }}
                <small>TL</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Active Users By Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getAttendanceSummaryActiveUser"
                  v-model="activeUserByAreaDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Area</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyActiveUserByArea.slice(0, 5)"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div
                class="col-xl-6 col-lg-12 col-sm-6"
                v-if="monthlyActiveUserByArea.length > 5"
              >
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyActiveUserByArea.slice(5, 10)"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Active Team Listing
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getAttendanceSummaryActiveTeam"
                  v-model="activeTeamByDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Teams</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyActiveTeam.slice(0, 5)"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-7">
                    {{ `${data.team ? data.team.name : ""}` }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div
                class="col-xl-6 col-lg-12 col-sm-6"
                v-if="monthlyActiveTeam.length > 5"
              >
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyActiveTeam.slice(5, 10)"
                >
                  <dt class="col-1">
                    {{ (index += 1) }}.
                  </dt>
                  <dt class="col-8">
                    {{ `${data.team ? data.team.name : ""}` }}
                  </dt>

                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<style scoped>
.attendance-and-payroll-summary
  .top-navbar
  .top-navbar-right
  button:first-child {
  margin-right: 20px;
}
</style>

<script>
import {
  getDashboardDate,
  checkPermission,
  getAttendanceSummary,
  getAttendanceMonthlyActiveUserByArea,
  getAttendanceMonthlyActiveTeam
} from "../api";
import { getProj } from "../helpers";
import Loader from "./Loader";

export default {
  components: {
    appLoader: Loader
  },
  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      isLoading: true,
      projectId: getProj()["projId"],
      monthlyDateFilter: [],
      dailyActiveBa: [],
      dailyActiveTl: [],
      activeUserByAreaDate: thisMonday,
      activeTeamByDate: thisMonday,
      monthlyActiveUserByArea: [],
      monthlyActiveTeam: [],
      restrictViewUsers: false
    };
  },
  async mounted() {
    this.restrictViewUsers = await this.checkPermission(
      "restrict payroll details"
    );
    await this.getDate();
    await this.getAttendanceSummaryData();
    await this.getAttendanceSummaryActiveUser();
    await this.getAttendanceSummaryActiveTeam();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const params = { dateType: "month" };
        const result = await getDashboardDate(params);
        this.monthlyDateFilter = result.data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async checkPermission(permission) {
      try {
        const result = await checkPermission({ permission: permission });
        return result.data.data;
      } catch (err) {
        return false;
      }
    },
    async getAttendanceSummaryData() {
      try {
        const params = { projectId: this.projectId };
        const result = await getAttendanceSummary(params);
        this.dailyActiveBa = result.data.data.statistics.ba;
        this.dailyActiveTl = result.data.data.statistics.tl;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getAttendanceSummaryActiveUser() {
      try {
        const params = {
          projectId: this.projectId,
          date: this.activeUserByAreaDate
        };
        const result = await getAttendanceMonthlyActiveUserByArea(params);
        this.monthlyActiveUserByArea = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getAttendanceSummaryActiveTeam() {
      try {
        const params = {
          projectId: this.projectId,
          date: this.activeUserByAreaDate
        };
        const result = await getAttendanceMonthlyActiveTeam(params);
        this.monthlyActiveTeam = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    }
  }
};
</script>
